import React from 'react';
import { announcements } from '../../data/mock';

const AnnouncementBar = () => {
  // Duplicate announcements for seamless loop
  const duplicatedAnnouncements = [...announcements, ...announcements, ...announcements];

  return (
    <div className="bg-[#1a1a1a] text-white py-1 md:py-2 overflow-hidden">
      <div className="animate-marquee whitespace-nowrap flex">
        {duplicatedAnnouncements.map((announcement, index) => (
          <span
            key={index}
            className="mx-6 md:mx-8 text-[10px] md:text-sm font-medium tracking-wider cursor-pointer hover:opacity-80 transition-opacity"
          >
            {announcement}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
